/*
 * � 2025, NTT Data Group. All rights reserved. See LICENSE.txt file in the project root for third party licenses info.
 */

import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { PATHS } from "../../utils/constants";

@Component({
	selector: "globalictcc-footer",
	standalone: true,
	imports: [RouterLink],
	templateUrl: "./footer.component.html",
	styleUrl: "./footer.component.scss"
})
export class FooterComponent {
	public readonly paths = PATHS;
	public readonly currentYear = new Date().getFullYear();
}
